export default {
  isLoading: false,
  error: false,
  errorMessage: null,
  orderDisplays: [],
  status: null
};
